import testHybrid from './testHybrid.json';
import testPrepopulatedImportedTemplates from './testPrepopulatedImportedTemplates.json';
import testLocalTemplatesOnly from './testLocalTemplatesOnly.json';

export default [testHybrid, testPrepopulatedImportedTemplates, testLocalTemplatesOnly];
